import { apiRequest } from './client'
import type { ApiBlogPost, BlogPostStatus } from './types'

export function listBlogPosts(status?: BlogPostStatus): Promise<ApiBlogPost[]> {
  return apiRequest<ApiBlogPost[]>('/blogs', {
    query: { status },
  })
}

export function getBlogBySlug(slug: string): Promise<ApiBlogPost> {
  return apiRequest<ApiBlogPost>(`/blogs/by-slug/${encodeURIComponent(slug)}`)
}
